import React from "react";
import { MixedWidget1 } from "../widgets";
export function Demo1Dashboard() {
    return (<>
        <div className="row">
            <div className="col-lg-6 col-xxl-4">
                <MixedWidget1 className="card-stretch gutter-b" />
            </div>
        </div>
    </>);
}
